export default {
  name: "HomePage",
  methods: {
    scrollToDiv(refName) {
      const targetDiv = this.$refs[refName];
      console.log(refName);
      // 使用scrollIntoView方法滚动到目标<div>
      targetDiv.scrollIntoView({
        behavior: 'smooth' // 可选，平滑滚动效果
      });
    },
    change(refName) {
      if (refName == 'target-cloud') {
        this.scrollToDiv('cloud');
      } else if (refName == 'target-Ai') {
        this.scrollToDiv('ai');
      } else {
        this.scrollToDiv('solution');
      }
    }
  },
  mounted() {
    // 从路由参数中获取目标元素的引用名称
    const refName = this.$route.query.refName;
    if (refName) {
      this.change(refName);
    }
  },
  watch: {
    '$route.query.refName': {
      immediate: true,
      handler(newRefName) {
        if (newRefName) {
          this.change(newRefName);
        }
      }
    }
  }
};